<script>
import Layout from "../../layouts/auth";
//import router from '../../routes'
import router from '../../../router/index'
import appConfig from "@/app.config";
import { apiService } from '@/helpers/api.service';

/**
 * Login component
 */
export default {
  page: {
    title: "OpenResto",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    //
  },
  methods: {
    openMyResto() {
      this.isOpen = true
      router.push({path:'/welly/resto?title=Estos son tus wellys del día'}).catch(() => {});
      this.openClose()
    },
    keepClosed() {
      this.isOpen = false
      this.openClose()
    },
    openClose(){
      let user = JSON.parse(localStorage.getItem('user')).data.user
      let store = localStorage.getItem('store') != "undefined" ? JSON.parse(localStorage.getItem('store')) : {"name": user.name, "isOpen": false}

      store.isOpen = this.isOpen
      localStorage.setItem('store', JSON.stringify(store));
      apiService.patchStore({"isOpen": this.isOpen})
      .then(() => {
            router.push({path:'/welly/resto?title=Estos son tus wellys del día'}).catch(() => {});
      })
    },
  },
  mounted() {
      apiService.getStoreById()
  }
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-sm-1 col-md-1 col-lg-1">
      </div>
      <div class="col-sm-10 col-md-10 col-lg-10">
        <div>
          <div>
            <br/><br/><br/><br/>

            <div class="row">
              <div class="col-lg-12 center"> 
                <router-link tag="a" to="/">
                  <img src="@/assets/images/placard.png" alt height="100" />
                </router-link>
              </div>
            </div>

            <br/>

            <div class="text-resto">
              ¡Hola! Tu tienda se encuentra 
              <br/>
              <b>cerrada.</b> 

              <br/><br/>
              <b>¿Te gustaría abrir la tienda ahora?</b>
              <br/>
              <b>Esto va a permitir que tus clientes</b>
              <br/>
              <b>puedan realizar órdenes.</b>
            </div>

            <div class="p-2">
              
              <br/>
              <div class="center">
                <b-button type="submit" variant="success" class="btn-width" @click="openMyResto()">
                  Abrir tienda
                </b-button>
              </div>

              <br/>
              <div class="center">
                <b-button type="submit" variant="outline-secondary" class="btn-width" style="position:relative; left: 5px;" @click="keepClosed()">
                  Permanecer cerrada
                </b-button>
              </div>
            </div>

            <br/><br/><br/><br/>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <!-- end row -->
      </div>
      <div class="col-sm-1 col-md-1 col-lg-1">
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>

</style>
